module.exports = __webpack_public_path__ + "static/back4.b4412d5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Gremlinz/back4.jpg
// module id = 1695
// module chunks = 249972491463148